var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWpforms = function SvgWpforms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5v22h22V5zm2 2h.535l5.065 4.3 3.4-3 3.4 3L24.465 7H25v18H7zm3.705 0h3.82L12.6 8.7zm6.77 0h3.82L19.4 8.7zM9 13v2h3v-2zm5 0v2h9v-2zm-5 4v2h3v-2zm5 0v2h9v-2zm4 4v2h5v-2z"
  })));
};
export default SvgWpforms;